import { getOptionLabel } from "./lib";

export const getPersonsOptionLabel = (employees) => {
  for (const employee of employees) {
    getOptionLabel(employee);
  }
};
